export const css = {
	microViewWrapper: '_2TU058kw',
	microView: 'p1_7toB3',
	titleBlock: '_2lyGETy2',
	' _key': 'apic-theme/apic/micro/quiz-widgets/quizfolder'
};

export default css;
